import React, { useCallback, useState } from 'react';
import { useSend } from '@sc1/common/hooks';
import { bulkInputToArray, VaultUpgradable } from '@sc1/common';
import { Box, Row, Card, Heading, Input, Switch, Textarea } from '../core';
import { StatusButton } from '../StatusButton';
import type { CardProps } from 'theme-ui';

interface SetAllowedProps extends CardProps {
  vault: VaultUpgradable | undefined;
  disabled: boolean;
}
export const SetAllowed = ({
  vault,
  disabled,
  ...rest
}: SetAllowedProps): JSX.Element => {
  const [address, setAddress] = useState<string>('');
  const [bulk, setBulk] = useState<boolean>(false);
  const [bulkAddresses, setBulkAddresses] = useState<string[]>([]);

  const { sendTx, txStatus } = useSend();
  const { sendTx: sendTx1, txStatus: txStatus1 } = useSend();

  const setAllowed = useCallback(
    () => vault && sendTx(vault, 'setAllowed', [address, true]),
    [vault, address, sendTx]
  );

  const setBulkAllow = useCallback(
    () => vault && sendTx(vault, 'bulkAllow', [bulkAddresses]),
    [vault, bulkAddresses, sendTx]
  );

  const removeAllowed = useCallback(
    () => vault && sendTx1(vault, 'setAllowed', [address, false]),
    [vault, address, sendTx1]
  );

  return (
    <Card {...rest}>
      <Heading as="h3" mb={3}>
        Set Allowed
      </Heading>
      <Box>
        <Switch
          sx={{ mb: 3 }}
          label="Bulk Add"
          checked={bulk}
          onChange={() => setBulk(!bulk)}
          disabled={disabled}
        />
        {bulk ? (
          <Box>
            <Textarea
              mb={2}
              disabled={disabled}
              placeholder="0x... Separate addresses by comma, space, or linebreak"
              onChange={(e) =>
                setBulkAddresses(bulkInputToArray(e.target.value))
              }
            />
            <Row variant="collapse">
              <StatusButton
                disabled={disabled}
                onClick={setBulkAllow}
                status={txStatus}
              >
                Assign
              </StatusButton>
            </Row>
          </Box>
        ) : (
          <Row variant="collapse">
            <Input
              disabled={disabled}
              placeholder="0x..."
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
            <Box my={1} mx={1} />
            <StatusButton
              disabled={disabled}
              onClick={setAllowed}
              status={txStatus}
            >
              Assign
            </StatusButton>
            <Box my={1} mx={1} />
            <StatusButton
              disabled={disabled}
              onClick={removeAllowed}
              status={txStatus1}
            >
              Revoke
            </StatusButton>
          </Row>
        )}
      </Box>
    </Card>
  );
};
